/**
 * 打赏资源
 */
export async function requestRewardResource(
  resourceId: number,
  resourceType: number,
  count: number
) {
  return http.post('/v1/reward/reward', {
    id: resourceId,
    type: resourceType,
    count
  })
}
